import WatchImg from "./WatchImg";
import { IconChevronLeft, IconChevronRight, IconX } from "./Icons";

const LightboxModal = ({
  lightboxOpen,
  setLightboxOpen,
  watchImages,
  activeImg,
  setActiveImg,
  goPrev,
  goNext,
  watch,
}) => {
  if (!lightboxOpen) {
    return null;
  }

  return (
    <div className="lightbox-overlay" onClick={() => setLightboxOpen(false)}>
      <button
        className="lightbox-close"
        onClick={() => setLightboxOpen(false)}
        aria-label="Close"
      >
        <IconX />
      </button>
      {watchImages?.length > 1 && (
        <button
          className="lightbox-arrow lightbox-arrow-left"
          onClick={(e) => {
            e.stopPropagation();
            goPrev();
          }}
          aria-label="Previous image"
        >
          <IconChevronLeft />
        </button>
      )}
      <div className="lightbox-img-wrap" onClick={(e) => e.stopPropagation()}>
        <WatchImg
          src={watchImages?.[activeImg]?.file_url}
          alt={watch?.name}
          className="lightbox-img"
        />
      </div>
      {watchImages?.length > 1 && (
        <button
          className="lightbox-arrow lightbox-arrow-right"
          onClick={(e) => {
            e.stopPropagation();
            goNext();
          }}
          aria-label="Next image"
        >
          <IconChevronRight />
        </button>
      )}
      {watchImages?.length > 1 && (
        <div className="lightbox-dots">
          {watchImages?.map((_, i) => (
            <span
              key={i}
              className={`lightbox-dot ${i === activeImg ? "active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                setActiveImg(i);
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default LightboxModal;
